import { uniq } from "lodash";
import { useGetAssetPermissionsMutation } from "redux/media/media.api";

export const useFetchPermissions = () => {
  const [getAssetPermissions] = useGetAssetPermissionsMutation();

  return async (folderIds: string[], action: WDPermsAsset | WDPermsFolder) => {
    const ids = uniq(folderIds).join(",");
    const perms = await getAssetPermissions(ids).unwrap();

    return perms.includes(action);
  };
};
